<div
  class="product-card-expand-container"
  [style.box-shadow]="productCard()?.productFrameLabelShadow() | safeStyle"
>
  <header class="d-flex">
    <div class="header-holder">
      <ng-content select="[header]"></ng-content>
    </div>
    @if(isReverse()) { @if(isExpanded()) {
    <button
      class="btn d-none d-sm-block"
      (click)="
        isKeepOpen.set(false); productCard()?.expandSimilarProducts(false)
      "
    >
      <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
    </button>
    } @else { @if(isPeekIcon()) {
    <button
      class="btn d-none d-sm-block px-1 line-height-1 pb-0 mr-1"
      (click)="keepOpen.emit(); isKeepOpen.set(true)"
    >
      <span class="text-center text-muted text-nowrap"
        >👀<small><em class="peek-text">peek</em></small></span
      >
    </button>
    } @else {
    <button
      class="btn d-none d-sm-block"
      (click)="keepOpen.emit(); isKeepOpen.set(true)"
    >
      <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
    </button>
    } } } @else { @if(isExpanded()) {
    <button
      class="btn d-none d-sm-block"
      (click)="
        isKeepOpen.set(false); productCard()?.expandSimilarProducts(false)
      "
    >
      <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
    </button>
    } @else { @if(isPeekIcon()) {
    <button
      class="btn d-none d-sm-block px-1 line-height-1 pb-0 mr-1"
      (click)="keepOpen.emit(); isKeepOpen.set(true)"
    >
      <span class="text-center text-muted text-nowrap"
        >👀<small><em class="peek-text">peek</em></small></span
      >
    </button>
    } @else {
    <button
      class="btn d-none d-sm-block"
      (click)="keepOpen.emit(); isKeepOpen.set(true)"
    >
      <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
    </button>
    } } }
  </header>
  <div>
    <div class="expand-main">
      <ng-content></ng-content>
    </div>
    @if(isExpanded()) {
    <article class="expand-details">
      <div class="expand-details-inner">
        @switch (shownProductType()) { @case
        (ProductExpandDetailsContentType.Information) {
        <atx-attributes-panel
          [data]="selectedVariantWithDescriptionAttributesFallback()"
          [componentDef]="panelDef()"
          class="pt-0 pb-3"
          data-e2e="product-details"
        ></atx-attributes-panel
        >} @case (ProductExpandDetailsContentType.SimilarProducts) {
        <epc-similar-products-container
          class="px-1"
          [productId]="productSignal()?.productId"
          [brandId]="productSignal()?.brandId"
        ></epc-similar-products-container>
        } }
      </div>
      @if(showFooterButton()) {
      <footer>
        @switch (shownProductType()) { @case
        (ProductExpandDetailsContentType.Information) {
        <button
          class="btn d-none d-sm-block btn-primary"
          (click)="showSimilarProducts()"
          i18n="
            product|Product information buttons@@productExpandButtonShowPanel"
        >
          Show Similar Products
        </button>
        } @case (ProductExpandDetailsContentType.SimilarProducts) {
        <button
          class="btn d-none d-sm-block btn-primary"
          (click)="showInformationPanel()"
          i18n="
            product|Product information
            buttons@@productExpandButtonShowInformation"
        >
          Show Product Information
        </button>
        } }
      </footer>
      }
    </article>
    }
  </div>
</div>
